<template>
  <div style="width:100%;">
    <div class="upload-name" style="width:100%;">
      <input v-model="fileName" disabled="disabled" />
      <button
        v-if="file != null || saveData.fileName"
        class="resetButton"
        @click="resetFile"
        style="border: none; display:inline-flex"
      >
        <font-awesome-icon icon="times-circle" style="font-size:20px" />
      </button>
    </div>
    <label for="file" style="white-space: nowrap;">업로드</label>
    <input type="file" id="file" class="upload-hidden" @change="setFileName" />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["saveData"],
  data() {
    return {
      file: null,
    };
  },
  computed: {
    fileName() {
      if (this.file) {
        this.saveData.fileName = this.file.name;
        return this.file.name;
      } else if (this.saveData.fileName) {
        return this.saveData.fileName;
      } else {
        return "";
      }
    },
  },
  methods: {
    ...mapActions("file", ["requestDeleteByFileGroupId"]),
    resetFile() {
      if (this.file) {
        this.file = null;
        this.saveData.file = null;
      } else if (this.saveData.fileName) {
        var response = this.$createConfirmResponse();
        this.$confirm(
          "알림",
          `업로드된 첨부파일을 삭제하시겠습니까?`,
          "확인",
          "취소",
          response,
          {
            closed: () => {
              if (response.result) {
                this.requestDeleteByFileGroupId(this.saveData.fileGroupId)
                  .then(() => {
                    this.$alert("알림", "첨부파일이 삭제되었습니다.", "", {
                      closed: () => {
                        this.$router.go();
                      },
                    });
                  })
                  .catch(() => {
                    this.$alert("알림", "첨부파일을 삭제할 수 없습니다.");
                  });
              }
            },
          }
        );
      }
    },
    setFileName(event) {
      let fileName = event.target.files[0].name;

      let fileNameArr = fileName.split(".");
      let ext = fileNameArr[fileNameArr.length - 1];

      let checkExts = [
        "mp4"
      ];

      var check = checkExts.some(function(checkExt) {
        return ext === checkExt;
      });

      if (!check) {
        this.$alert(
          "알림",
          "업로드가 불가한 확장자입니다. <br>(mp4 파일만 업로드할 수 있습니다.)"
        );
        return;
      }

      var maxSize = 30 * 1024 * 1024 * 1024;
      if (event.target.files[0].size > maxSize) {
        this.$alert("알림", "첨부파일은 30GB 이하의 크기만 업로드 가능합니다.");
        return;
      }

      this.file = event.target.files[0];
      this.$emit("set-file", this.file);
    },
  },
};
</script>

<style scoped lang="scss">
.resetButton {
  color: #989898;
  cursor: pointer;
}
.resetButton:hover {
  color: #2d2d2d;
}
</style>
